import { CommonModule, CurrencyPipe, DatePipe, NgClass } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { DashboardService } from '../../_services/dashboard.service';
import { UsersService } from '../../_services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SliderProprtiesComponent } from './slider-proprties/slider-proprties.component';
import { RouterOutlet } from '@angular/router';
import { InrShortPipe } from '../../_pipes/indian-currency.pipe';

// import { RouterLink } from "@angular/router";
export interface Stat {
  title: string;
  value: string;
  change: string;
  changeColorClass: string;
  iconPath: string;
  iconBgClass: string;
  iconColorClass: string;
  period: string;
}
interface StatCard {
  title: string;
  value: number;
  change: string;
  period: string;
  iconBgClass: string;
  iconColorClass: string;
  changeColorClass: string;
  iconPath: string;
}
 
interface StatsResponse {
  success: boolean;
  data: {
    users: {
      total: number;
      todaySignups: number;
      withAdvisor: number;
      byUserType: { _id: string; count: number }[];
    };
    advisors: {
      total: number;
      advisors: {
        _id: string;
        name: string;
        assignedUserCount: number;
        assignedPropertyCount: number;
      }[];
      approvalBreakdown: { _id: boolean; count: number }[];
    };
    properties: {
      total: number;
      todayAdded: number;
      todayDeleted: number;
      soldOut: number;
      updatedToday: number;
    };
    shares: {
      total: number;
      todayShared: number;
      activeShares: number;
      expiredShares: number;
    };
  };
}


@Component({
  selector: 'app-dashboard',
  imports: [NgClass, DatePipe, CommonModule,InrShortPipe],
  providers: [InrShortPipe],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone:true
})

export class DashboardComponent implements OnInit {

  stats = signal<Stat[]>([]);
  recentOrders:any = signal([]);
  recentAduser:any = signal([]);
  topProducts:any = signal([]);
  isLoading = signal(false);
  statData = signal<StatCard[]>([]);
  loading = signal(true);
  currentYear:any = new Date();
  isMenuHidden = true;  // menu default hidden
  errorMessage:string = ''
  private _snackBar = inject(MatSnackBar);
  advisorList = signal<any[]>([]);
  usersList = signal<any[]>([]);
  activeUsersCount = 0;
  assignedUsersCount = 0;
  unassignedUsersCount = 0;
  totalUsersCount = 0;
  statsRawData: any;
  usersReady = false;
  statsReady = false;

 constructor(private _DS : DashboardService, private inrShortPipe: InrShortPipe, private userService: UsersService){}

  ngOnInit(): void {
    this.loadDashboardData();
    this.getStatsData();
    this.getUsers();
  }
  
  getUsers() {
    this.userService.getAllUser().subscribe((res: any) => {
      const users = Array.isArray(res) ? res : [];

      this.usersList.set(users);

      this.calculateUserStats(users);

      if (this.statsRawData) {
        const cards = this.mapToCards(this.statsRawData);
        this.statData.set(cards);
        this.loading.set(false);
      } else {
        console.warn('Stats not ready yet');
      }
    });
  }
  calculateUserStats(users: any[] = []) {
    this.totalUsersCount = users.length;

    const activeUsers = users.filter(
      u => u.isApproved && u.state === 'Approved'
    );

    this.activeUsersCount = activeUsers.length;

    const totalAssignedUsers =
      this.statsRawData?.advisors?.advisors?.reduce(
        (sum: number, advisor: any) =>
          sum + (advisor.assignedUserCount || 0),
        0
      ) || 0;

    this.assignedUsersCount = totalAssignedUsers;

    this.unassignedUsersCount =
      this.activeUsersCount - totalAssignedUsers;

  }

  toggleMenu() {
    this.isMenuHidden = !this.isMenuHidden;
  }

  scrollTo(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    this.isMenuHidden = true;
  }

  loadDashboardData(): void {
    this.isLoading.set(true);
    this._DS.getDashboardData().subscribe((res:any)=>{
      this.isLoading.set(false);
      try {
        // this.stats.set(res.data.stats);
        this.recentOrders.set(res.data.recentUsers);
        this.topProducts.set(res.data.recentProperties);
        this.recentAduser.set(res.data.recentContactRequests);
      } catch (error) {
        this.errorMessage = res.message || 'Invalid credential';
        this._snackBar.open(this.errorMessage, 'close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      }
    })
  }
  // getStats
  getStatsData() {
    this._DS.getStats().subscribe((res: any) => {
      console.log('Stats API hit');

      if (res.success) {
        this.statsRawData = res.data;

        this.advisorList.set(res.data.advisors.advisors);

        // ✅ If users already loaded → build cards
        if (this.usersList().length > 0) {
          const cards = this.mapToCards(this.statsRawData);
          this.statData.set(cards);
          this.loading.set(false);
        }
      }
    });
  }
  formatPriceDisplay(priceData: any): string {
    if (!priceData) return 'N/A';
    if (Array.isArray(priceData)) {
      if (priceData.length === 0) return 'N/A';
      const values = priceData
        .map((p) => Number(p.price))
        .filter((v) => !isNaN(v));
      if (values.length === 0) return 'N/A';

      const min = Math.min(...values);
      const max = Math.max(...values);
      if (values.length === 1 || min === max) {
        return this.inrShortPipe.transform(min);
      }
      return `${this.inrShortPipe.transform(
        min
      )} - ${this.inrShortPipe.transform(max)}`;
    }
    return this.inrShortPipe.transform(priceData);
  }

  

  mapToCards(data: any) {
    if (!data) {
      console.warn('mapToCards called with undefined data');
      return [];
    }

    const { properties, advisors } = data;

    return [
      {
        title: 'Total Users',
        value: this.totalUsersCount,
        change: `${this.activeUsersCount} approved`,
        period: `${this.assignedUsersCount} assigned to advisors`,
        iconBgClass: 'bg-blue-50',
        iconColorClass: 'text-blue-600',
        changeColorClass: 'text-gray-500',
        iconPath: 'M16 11a4 4 0 10-8 0 4 4 0 008 0zm-6 6h4a6 6 0 016 6H4a6 6 0 016-6z'
      },

      {
        title: 'Unassigned Users',
        value: this.unassignedUsersCount,
        change: 'Needs attention',
        period: 'Not mapped to advisors',
        iconBgClass: 'bg-red-50',
        iconColorClass: 'text-red-600',
        changeColorClass: 'text-red-500',
        iconPath: 'M15 11a3 3 0 11-6 0 3 3 0 016 0zm-3 4c-3.314 0-6 2.239-6 5h8m4-3h-4'
      },

      {
        title: 'Total Properties',
        value: properties?.total || 0,
        change: 'None added today',
        period: `${properties?.soldOut || 0} sold out`,
        iconBgClass: 'bg-yellow-50',
        iconColorClass: 'text-yellow-600',
        changeColorClass: 'text-gray-500',
        iconPath: 'M3 10l9-7 9 7v11a2 2 0 01-2 2h-4'
      },

      {
        title: 'Avg Users / Advisor',
        value: Math.round(
          this.assignedUsersCount / (advisors?.total || 1)
        ),
        change: 'Distribution health',
        period: `${advisors?.total || 0} advisors`,
        iconBgClass: 'bg-indigo-50',
        iconColorClass: 'text-indigo-600',
        changeColorClass: 'text-indigo-600',
        iconPath: 'M3 10h4l3 10 4-18 3 8h4'
      }
    ];
  }
}
